import { CountUp } from 'countup.js'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

/**
* EMFACECounters functionality.
 * @author Dayne Coulson-Hoffacker
 */

export default class EMFACECounters {
	/**
		 * Constructs a new EMFACECounters instance.
		 * @param {Object} options - Options.
		 * @param {HTMLElement} options.element - Container.
		 */

	constructor(options) {
		this.element = options.element

		ScrollTrigger.create({
			trigger: this.element,
			start: "top 70%",
			onEnter: () => {
				this.countStart()
			}
		})
	}
	countStart() {
		const $counters = this.element.querySelectorAll(".counter"),
		options = {
			useEasing: true,
			useGrouping: true,
			separator: ",",
			decimal: "."
		}
		$counters.forEach((item) => {
			const value = item.dataset.value;
			const counter = new CountUp(item, value, options);
			counter.start();
		})
	}
}
